import script from "./object_textWithTitles.vue?vue&type=script&setup=true&lang=js"
export * from "./object_textWithTitles.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__